import { createContext } from 'react';
import { GetAccountsTwrrParams } from '@goldwasserexchange/actor/rest-services';

export const accountsTwrrParamsContext = createContext<Partial<GetAccountsTwrrParams>>({});
